import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconGitlabColor24 = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#E24329",
			d: "m21.667 9.994-.028-.072-2.722-7.104a.71.71 0 0 0-.704-.446.73.73 0 0 0-.41.153.73.73 0 0 0-.241.367l-1.838 5.623H8.281L6.443 2.892a.7.7 0 0 0-.241-.368.73.73 0 0 0-.833-.044.7.7 0 0 0-.28.337L2.36 9.918l-.027.072a5.055 5.055 0 0 0 1.677 5.842l.009.007.025.018 4.147 3.105 2.051 1.553 1.25.944a.84.84 0 0 0 1.016 0l1.25-.944 2.051-1.553 4.172-3.124.01-.008a5.06 5.06 0 0 0 1.675-5.836"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FC6D26",
			d: "m21.667 9.994-.028-.072a9.2 9.2 0 0 0-3.66 1.646L12 16.088l3.808 2.879 4.172-3.124.01-.009a5.056 5.056 0 0 0 1.677-5.84"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FCA326",
			d: "m8.192 18.967 2.051 1.552 1.25.944a.84.84 0 0 0 1.016 0l1.25-.944 2.051-1.552s-1.774-1.343-3.81-2.879c-2.036 1.536-3.808 2.879-3.808 2.879"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FC6D26",
			d: "M6.02 11.568a9.2 9.2 0 0 0-3.659-1.65l-.027.072a5.055 5.055 0 0 0 1.677 5.842l.009.007.025.018 4.147 3.105L12 16.084z"
		})
	]
});
const ForwardRef = forwardRef(SvgIconGitlabColor24);
export default ForwardRef;
